// extracted by mini-css-extract-plugin
module.exports = {"mainScreen":"MainScreen_mainScreen__1rNnv"};